import { DataService } from './dataService'
export const productServices = {
	addProduct: async (data) => {
		return DataService.post('/admin/add_product', data)
	},

	getProductDetails: async (data) => {
		return DataService.get('/admin/get_product_details', data)
	},

	searchProduct: async (data) => {
		return DataService.get('/admin/search_product', data)
	},

	getProduct: async (data) => {
		return DataService.get('/admin/get_product', data)
	},

	updateProduct: async (data) => {
		return DataService.post('/admin/update_product', data)
	},

	updateProductStatus: async (data) => {
		return DataService.post('/admin/update_product_status', data)
	},

	deleteProduct: async (data) => {
		return DataService.post('/admin/delete_product', data)
	},
	importProductData: async (data) => {
		return DataService.post('/admin/import_product', data)
	},

	exportProductData: async (data) => {
		return DataService.get('/admin/export_product_data', data)
	},

}